import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import BackspaceIcon from '@mui/icons-material/Backspace';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useKioskContext } from '../context/KioskContext';

const TableNumber = ({ onTableSubmit, onBack }) => {
  const { translate, orderType, tableNumber, updateTableNumber } = useKioskContext();
  const [localTableNumber, setLocalTableNumber] = useState(tableNumber || '');

  // Handle number pad button click
  const handleNumberClick = (num) => {
    // Limit to reasonable table number length
    if (localTableNumber.length < 4) {
      setLocalTableNumber(prev => prev + num);
    }
  };

  // Handle backspace button click
  const handleBackspace = () => {
    setLocalTableNumber(prev => prev.slice(0, -1));
  };

  // Handle clear button click
  const handleClear = () => {
    setLocalTableNumber('');
  };

  // Handle submit button click
  const handleSubmit = () => {
    if (localTableNumber) {
      // Update the table number in the context
      updateTableNumber(localTableNumber);
      // Also call the provided callback
      onTableSubmit(localTableNumber);
    }
  };

  // Generate number pad buttons
  const renderNumberPad = () => {
    const numbers = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
    return (
      <Grid container spacing={2}>
        {numbers.map((num) => (
          <Grid item xs={4} key={num} sx={{ display: num === '0' ? 'block' : 'block' }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => handleNumberClick(num)}
              sx={{
                py: 2,
                fontSize: '1.5rem',
                backgroundColor: 'primary.main',
                '&:hover': {
                  backgroundColor: 'primary.dark',
                },
              }}
            >
              {num}
            </Button>
          </Grid>
        ))}
        <Grid item xs={4}>
          <Button
            variant="contained"
            color="error"
            fullWidth
            onClick={handleClear}
            sx={{
              py: 2,
              fontSize: '1.5rem',
            }}
          >
            C
          </Button>
        </Grid>
        <Grid item xs={4}>
          <Button
            variant="contained"
            color="secondary"
            fullWidth
            onClick={handleBackspace}
            sx={{
              py: 2,
              fontSize: '1.5rem',
            }}
          >
            <BackspaceIcon />
          </Button>
        </Grid>
      </Grid>
    );
  };

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: 3,
        backgroundColor: '#f5f5f5',
      }}
    >
      {/* Logo */}
      <Box sx={{ mb: 2, textAlign: 'center' }}>
        <img 
          src="/assets/images/logo.png" 
          alt="Sparkle Pay" 
          style={{ maxWidth: '250px', marginBottom: '10px' }} 
        />
      </Box>

      {/* Back Button */}
      <Box sx={{ position: 'absolute', top: 20, left: 20 }}>
        <IconButton 
          onClick={onBack} 
          color="primary"
          sx={{ bgcolor: 'background.paper', '&:hover': { bgcolor: 'background.default' } }}
        >
          {/* <ArrowBackIcon fontSize="large" /> */}
        </IconButton>
      </Box>

      <Typography variant="h3" component="h1" align="center" gutterBottom>
        {translate('Enter Table Number', {
          en: 'Enter Table Number',
          zh: '输入桌号',
          th: 'ป้อนหมายเลขโต๊ะ',
          tl: 'Ilagay ang Numero ng Mesa'
        })}
      </Typography>

      <Paper
        elevation={3}
        sx={{
          width: '100%',
          maxWidth: 500,
          mx: 'auto',
          p: 3,
          borderRadius: 2,
        }}
      >
        {/* Display area */}
        <Paper
          variant="outlined"
          sx={{
            p: 2,
            textAlign: 'center',
            mb: 3,
            height: 80,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 1,
            backgroundColor: '#f9f9f9',
          }}
        >
          <Typography variant="h2">
            {localTableNumber || ' '}
          </Typography>
        </Paper>

        <Divider sx={{ my: 2 }} />

        {/* Number pad */}
        {renderNumberPad()}

        <Box sx={{ mt: 3 }}>
          <Button
            variant="contained"
            color="success"
            fullWidth
            size="large"
            onClick={handleSubmit}
            disabled={!localTableNumber}
            startIcon={<CheckCircleIcon />}
            sx={{
              py: 2,
              fontSize: '1.2rem',
            }}
          >
            {translate('Confirm', {
              en: 'Confirm',
              zh: '确认',
              th: 'ยืนยัน',
              tl: 'Kumpirmahin'
            })}
          </Button>
        </Box>
      </Paper>

    </Box>
  );
};

export default TableNumber;
